//
//
//
//
//
//
//
//

export default {
  setup() {
    const date = new Date().toISOString().substr(0, 10)

    return { date }
  },
}
